import { Card, message } from 'antd'
import React, { useContext, useEffect, useState } from 'react'
import './dashboard.scss'
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler } from 'chart.js'
// import faker from 'faker';
import { Line } from 'react-chartjs-2'
import dashboardService from '../../services/dashboardService'
import { responseDateEarningPair, earningPairMapping } from '../functions'
import { ThemeContext } from '../../context/themeProvider'

const ROOT = `dashboard_module`
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler)

export default function MyEarningsGraph(props) {
  const { cardBackgroundColor } = props
  const [graphData, setGraphData] = useState()
  const [graphEarning, setGraphEarning] = useState()
  const [xLabel, setXLabel] = useState('')
  const { setLoading } = useContext(ThemeContext)

  useEffect(() => {
    getDetailsFunc()
  }, [])

  const getDetailsFunc = async () => {
    try {
      setLoading(true)
      const response = await dashboardService.getTransactionGraph()
      // console.log('verify', verifyUser)
      if (response.error) {
        message.destroy()
        message.error(response?.error?.message || 'Something went worng in getting user details')
      } else {
        let pairArray = responseDateEarningPair(response?.data)
        setGraphData(earningPairMapping(pairArray))
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
      return
    }
  }

  useEffect(() => {
    if (graphData) {
      setXLabel(graphData?.map(ele => ele.date.split(',')[0]))
      // console.log(graphData?.map(ele => ele.date.split(',')[0]))
      setGraphEarning(graphData?.map(ele => Number(ele.earning)))
      // console.log(result?.map(ele => Number(ele.earning)))
    }
  }, [graphData])

  const options = {
    responsive: true,
    scales: {
      x: {
        beginAtZero: true,
      },
      y: {
        beginAtZero: true,
      },
    },
  }

  const data = {
    labels: xLabel,
    datasets: [
      {
        label: '',
        data: graphEarning,
        borderColor: '#1982CE', // Set the line color to blue
        pointBackgroundColor: 'white', // Set the fill color with opacity (adjust the color and opacity as needed)
        backgroundColor: 'rgba(25, 130, 206, 0.3)', // Set the fill color with opacity (adjust the color and opacity as needed)
        tension: 0.1,
        pointRadius: 8,
        borderWidth: 1,
        fill: true,
      },
    ],
  }
  return (
    <Card
      className={`${ROOT}__graph_ui`}
      style={{ backgroundColor: `${cardBackgroundColor}` }}
      title="Earnings"
      extra={
        // <Select
        //   defaultValue="Referrals"
        //   style={{
        //     width: 120,

        //   }}
        //   onChange={handleChange}
        //   options={[
        //     {
        //       value: "Daily",
        //       label: "Daily",
        //     },
        //     {
        //       value: "Weekly",
        //       label: "Weekly",
        //     },
        //     {
        //       value: "Monthly",
        //       label: "Monthly",
        //     },
        //   ]}
        // />
        <select
          className="select_filter"
          // onChange={e => console.log(e.target.value)}
        >
          <option value="referrals">Referrals</option>
          <option
            disabled
            value="engagements"
          >
            Engagement
          </option>
        </select>
      }
    >
      <div style={{ width: '100%' }}>
        <Line
          options={options}
          data={data}
          style={{ width: '100%', height: '200px' }}
        />
      </div>
    </Card>
  )
}
